const ZDANIA60 = [
  {
    name: "[6 klasa] Niem Marzec 2024 - słówka - 2",
    lang: 'de',
    zdania: [
      {
        pl: "zawód",
        de: "der Beruf",
      },
      {
        pl: "muzyk",
        de: "der Musiker",
      },
      {
        pl: "taksówkarz",
        de: "der Taxifahrer",
      },
      {
        pl: "fotograf",
        de: "der Fotograf",
      },
      {
        pl: "polityk",
        de: "der Politiker",
      },
      {
        pl: "policjant",
        de: "der Polizist",
      },
      {
        pl: "inżynier",
        de: "der Ingenieur",
      },
      {
        pl: "architekt",
        de: "der Architekt",
      },
      {
        pl: "dziennikarz",
        de: "der Journalist",
      },
      {
        pl: "urzędnik",
        de: "der Beamte",
      },
      {
        pl: "kucharz",
        de: "der Koch",
      },
      {
        pl: "piosenkarz",
        de: "der Sänger",
      },
      {
        pl: "aktor",
        de: "der Schauspieler",
      },
      {
        pl: "Co robi twoja mama zawodowo?",
        de: "Was ist deine Mutter von Beruf?",
      },
      {
        pl: "W tej grupie grają dobrzy muzycy.",
        de: "In dieser Band spielen gute Musiker.",
      },
      {
        pl: "On jest taksówkarzem i pracuje w nocy.",
        de: "Er ist Taxifahrer und arbeitet nachts.",
      },
      {
        pl: "Fotograf robi zdjęcia.",
        de: "Der Fotograf macht Fotos.",
      },
      {
        pl: "Politycy wiele obiecują.",
        de: "Politiker versprechen viel.",
      },
      {
        pl: "Policjanci noszą mundur.",
        de: "Polizisten tragen eine Uniform.",
      },
      {
        pl: "Twój syn chce zostać inżynierem.",
        de: "Ihr Sohn will Ingenieur werden.",
      },
      {
        pl: "Architekt musi dużo rysować.",
        de: "Ein Architekt muss viel zeichnen.",
      },
      {
        pl: "Dziennikarze są często krytyczni i inteligentni.",
        de: "Journalisten sind oft kritisch und intelligent.",
      },
      {
        pl: "Urzędnik ma stałą pracę.",
        de: "Ein Beamter hat eine feste Arbeit.",
      },
      {
        pl: "Mój wujek pracował w restauracji jako kucharz.",
        de: "Mein Onkel hat im Restaurant als Koch gearbeitet.",
      },
      {
        pl: "Udo Lindenberg to niemiecki piosenkarz.",
        de: "Udo Lindenberg ist ein deutscher Sänger.",
      },
      {
        pl: "Aktorzy grają w filmach i sztukach teatralnych.",
        de: "Schauspieler spielen in Filmen und Theaterstücken.",
      },
      {
        pl: "biuro",
        de: "das Büro",
      },
      {
        pl: "firma",
        de: "die Firma",
      },
      {
        pl: "projekt",
        de: "das Projekt",
      },
      {
        pl: "biurko",
        de: "der Schreibtisch",
      },
      {
        pl: "szef",
        de: "der Chef",
      },
      {
        pl: "kolega",
        de: "der Kollege",
      },
      {
        pl: "zaczynać",
        de: "anfangen",
      },
      {
        pl: "przestawać",
        de: "aufhören",
      },
      {
        pl: "dyrektor",
        de: "der Direktor",
      },
      {
        pl: "fabryka",
        de: "die Fabrik",
      },
      {
        pl: "plac budowy",
        de: "die Baustelle",
      },
      {
        pl: "Proszę, przyjdź do mojego biura.",
        de: "Bitte kommen Sie in mein Büro.",
      },
      {
        pl: "On pracuje w mojej firmie.",
        de: "Er arbeitet in meiner Firma.",
      },
      {
        pl: "Pracujemy nad projektem.",
        de: "Wir arbeiten am Projekt.",
      },
      {
        pl: "Siedzę przy biurku.",
        de: "Ich sitze am Schreibtisch.",
      },
      {
        pl: "Musisz porozmawiać z szefem.",
        de: "Du musst mit dem Chef sprechen.",
      },
      {
        pl: "On ma wielu kolegów.",
        de: "Er hat viele Kollegen.",
      },
      {
        pl: "Kiedy zaczynasz?",
        de: "Wann fängst du an?",
      },
      {
        pl: "Przestań!",
        de: "Hör auf!",
      },
      {
        pl: "Nasz dyrektor jest nieprzyjemny.",
        de: "Unser Direktor ist unfreundlich.",
      },
      {
        pl: "To jest stara, duża fabryka samochodów.",
        de: "Das ist eine alte, große Autofabrik.",
      },
      {
        pl: "Twój brat pracuje na placu budowy.",
        de: "Ihr Bruder arbeitet auf einer Baustelle.",
      },
    ],
  },
];

const ZDANIA61 = [
  {
    name: "[6 klasa] Ang Marzec cz.2 2024 - słówka",
    lang: 'en',
    zdania: [
      {
        pl: "dostęp",
        de: "access",
      },
      {
        pl: "pensjonat, internat",
        de: "boarding",
      },
      {
        pl: "obowiązkowy",
        de: "compulsory",
      },
      {
        pl: "program nauczania",
        de: "curriculum",
      },
      {
        pl: "wejście, wstęp",
        de: "entrance",
      },
      {
        pl: "do wyboru, fakultatywny",
        de: "elective",
      },
      {
        pl: "pozalekcyjny",
        de: "extracurricular",
      },
      {
        pl: "obcy, zagraniczny",
        de: "foreign",
      },
      {
        pl: "przerwa (np. w nauce, pracy)",
        de: "gap",
      },
      {
        pl: "ocena, klasa",
        de: "grade",
      },
      {
        pl: "ukończyć studia",
        de: "graduate",
      },
      {
        pl: "dyrektor szkoły",
        de: "headmaster",
      },
      {
        pl: "młodszy, niższy rocznik",
        de: "junior",
      },
      {
        pl: "żłobek",
        de: "nursery",
      },
      {
        pl: "szkoła podstawowa",
        de: "primary",
      },
      {
        pl: "publiczny",
        de: "public",
      },
      {
        pl: "szósta forma (ostatnie dwa lata szkoły średniej w UK)",
        de: "sixth form",
      },
      {
        pl: "semestr, okres nauki",
        de: "term",
      },
      {
        pl: "zawodowy",
        de: "vocational",
      },
      {
        pl: "tablica",
        de: "Blackboard",
      },
      {
        pl: "szkoła z internatem",
        de: "boarding school",
      },
      {
        pl: "oszukiwać",
        de: "cheat",
      },
      {
        pl: "ogólnokształcący",
        de: "comprehensive",
      },
      {
        pl: "stopień naukowy, tytuł",
        de: "degree",
      },
      {
        pl: "siłownia, sala gimnastyczna",
        de: "gym",
      },
      {
        pl: "szkoła średnia",
        de: "high school",
      },
      {
        pl: "instrukcje, polecenia",
        de: "instructions",
      },
      {
        pl: "uczestniczyć",
        de: "participate",
      },
      {
        pl: "publiczna, państwowa (o szkole)",
        de: "public",
      },
      {
        pl: "okres, termin",
        de: "term",
      },
      {
        pl: "plan zajęć",
        de: "timetable",
      },
    ],
  },
];

const ZDANIA62 = [
  {
    name: "[6 klasa] Niem Marzec cz.4 2024",
    lang: 'de',
    zdania: [
      {
        pl: "Victor i Rolf są bliźniakami.",
        de: "Victor und Rolf sind Zwillinge.",
      },
      {
        pl: "Jesteś jedynakiem?",
        de: "Bist du ein Einzelkind?",
      },
      {
        pl: "Czy to chłopiec czy dziewczynka?",
        de: "Ist das ein Junge oder ein Mädchen?",
      },
      {
        pl: "Mam dwoje dzieci: chłopca i dziewczynkę.",
        de: "Ich habe zwei Kinder: einen Jungen und ein Mädchen.",
      },
      {
        pl: "Moja siostra jest jeszcze niemowlęciem.",
        de: "Meine Schwester ist noch ein Baby.",
      },
      {
        pl: "On urodził się w Warszawie.",
        de: "Er ist in Warschau geboren.",
      },
      {
        pl: "Kiedy masz urodziny?",
        de: "Wann hast du Geburtstag?",
      },
      {
        pl: "Lubię mojego ojczyma.",
        de: "Ich mag meinen Stiefvater.",
      },
      {
        pl: "Ona jest jej macochą.",
        de: "Sie ist ihre Stiefmutter.",
      },
      {
        pl: "Pan Schmidt jest wdowcem już od dwóch lat.",
        de: "Herr Schmidt ist schon seit zwei Jahren Witwer.",
      },
      {
        pl: "Pan Schmidt chciałby poznać wdowę.",
        de: "Herr Schmidt möchte eine Witwe kennen lernen.",
      },
      {
        pl: "Markus, wiesz, że Tina chce zostać tenisistką?",
        de: "Markus, weißt du, dass Tina Tennisspielerin werden will?",
      },
      {
        pl: "Tak, i wiem też, że twoi rodzice nie są z tego bardzo zadowoleni.",
        de: "Ja, und ich weiß auch, dass deine Eltern davon nicht sehr begeistert sind.",
      },
      {
        pl: "Wiesz, że Stefan dobrze gra w piłkę nożną?",
        de: "Weißt du, dass Stefan gut Fußball spielt?",
      },
      {
        pl: "Tak, i wiem też, że chce zostać piłkarzem.",
        de: "Ja, und ich weiß auch, dass er Fußballspieler werden will.",
      },
      {
        pl: "Lena, wiesz, że ona lubi grać na komputerze?",
        de: "Lena, weißt du, dass sie gerne mit dem Computer spielt?",
      },
      {
        pl: "Tak, i wiem też, że chce zostać programistką.",
        de: "Ja, und ich weiß auch, dass sie Programmiererin werden will.",
      },
      {
        pl: "Ben, wiesz, że on lubi matematykę?",
        de: "Ben, weißt du, dass er Mathe mag?",
      },
      {
        pl: "Tak, i wiem też, że chce zostać matematykiem.",
        de: "Ja, und ich weiß auch, dass er Mathematiker werden will.",
      },
      {
        pl: "Martin, wiesz, że on lubi gotować?",
        de: "Martin, weißt du, dass er gerne kocht?",
      },
      {
        pl: "Tak, i wiem też, że chce zostać kucharzem.",
        de: "Ja, und ich weiß auch, dass er Koch werden will.",
      },
      {
        pl: "Eva, wiesz, że ona lubi samochody?",
        de: "Eva, weißt du, dass sie Autos mag?",
      },
      {
        pl: "Tak, i wiem też, że chce zostać mechanikiem samochodowym.",
        de: "Ja, und ich weiß auch, dass sie Automechanikerin werden will.",
      },
      {
        pl: "Anna, wiesz, że ona pięknie śpiewa?",
        de: "Anna, weißt du, dass sie schön singen kann?",
      },
      {
        pl: "Tak, i wiem też, że chce zostać piosenkarką.",
        de: "Ja, und ich weiß auch, dass sie Sängerin werden will.",
      },
      {
        pl: "Jakob, wiesz, że on trenuje koszykówkę?",
        de: "Jakob, weißt du, dass er Basketball trainiert?",
      },
      {
        pl: "Tak, i wiem też, że chce zostać koszykarzem.",
        de: "Ja, und ich weiß auch, dass er Basketballspieler werden will.",
      },
      {
        pl: "Vera, wiesz, że ona kocha zwierzęta?",
        de: "Vera, weißt du, dass sie Tiere liebt?",
      },
      {
        pl: "Tak, i wiem też, że chce zostać weterynarzem.",
        de: "Ja, und ich weiß auch, dass sie Tierärztin werden will.",
      },
      {
        pl: "Thomas, wiesz, że on lubi uprawiać sport?",
        de: "Thomas, weißt du, dass er gerne Sport macht?",
      },
      {
        pl: "Tak, i wiem też, że chce zostać nauczycielem wychowania fizycznego.",
        de: "Ja, und ich weiß auch, dass er Sportlehrer werden will.",
      },
    ],
  },
];

export { ZDANIA60, ZDANIA61, ZDANIA62 };
